var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"propertie-item",on:{"click":function($event){return _vm.click(_vm.id)}}},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"address"},[_vm._v(_vm._s(_vm.address))])])
}
var staticRenderFns = []

export { render, staticRenderFns }